import React, { Dispatch, SetStateAction } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Col, Row, Form } from 'react-bootstrap';
import { IBlogFacet, IBlogFacetItem, IBlogListRequest } from '../blogService';

export interface IBlogFilters {
  facets: IBlogFacet[];
  request: IBlogListRequest;
  setRequest: Dispatch<SetStateAction<IBlogListRequest>>;
}

const BlogFilters = ({ facets, request, setRequest }: IBlogFilters) => {
  const { t } = useTranslation('blog');

  const sectorFacet = facets.filter((sector) => sector.name === 'sectors')[0];
  const categoryFacet = facets.filter((category) => category.name === 'blogcategory')[0];

  const handleSectorChange = (sector: string) => {
    setRequest((prevRequest) => {
      const { sectors = [] } = prevRequest;

      const updatedSectors = sectors.includes(sector) ? sectors.filter((sectorItem) => sectorItem !== sector) : [...sectors, sector];

      return {
        ...prevRequest,
        sectors: updatedSectors,
        page: 1
      };
    });
  };

  const handleCategoryChange = (category: string) => {
    setRequest((prevRequest) => {
      const { categories = [] } = prevRequest;

      const updatedCategories = categories.includes(category)
        ? categories.filter((categoryItem) => categoryItem !== category)
        : [...categories, category];

      return {
        ...prevRequest,
        categories: updatedCategories,
        page: 1
      };
    });
  };

  return (
    <div>
      {' '}
      <h2 className="mb-2">{t('label.sectors')}</h2>
      <Row className="w-50">
        {sectorFacet.items.map((sector, idx) => (
          <Col xs={6} md={6} key={idx} className="mb-3">
            {' '}
            <Form.Check custom type="checkbox">
              <Form.Check.Input
                type="checkbox"
                id={idx.toString()}
                checked={request.sectors?.includes(sector.name)}
                onChange={() => handleSectorChange(sector.name)}
              />
              <Form.Check.Label htmlFor={idx.toString()} className={'font-weight-normal'}>
                {sector.name} ({sector.count})
              </Form.Check.Label>
            </Form.Check>
          </Col>
        ))}
      </Row>
      <h2 className="mb-3">{t('label.categories')}</h2>
      <Row>
        {categoryFacet.items.map((category: IBlogFacetItem, idx: number) => (
          <Col xs={6} md={4} key={idx} className="mb-3">
            <Form.Check custom type="checkbox">
              <Form.Check.Input
                type="checkbox"
                id={category.name}
                checked={request.categories?.includes(category.name)}
                onChange={() => handleCategoryChange(category.name)}
              />
              <Form.Check.Label htmlFor={category.name} className={'font-weight-normal'}>
                {category.name} ({category.count})
              </Form.Check.Label>
            </Form.Check>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default BlogFilters;
